// @flow
import React from 'react'
import I18n from 'i18n-react'

import FieldLabel from './FieldLabel'
import StringEnum from './_formFields/StringEnum'

import type { Sort } from '../Types/Sort'

type MiniMobileSortProps = {
  activeSorts: Array<Sort>,
  onSetSort: (sort: Sort) => void,
  sorts: Array<Object>,
}

const MiniMobileSort = (props: MiniMobileSortProps) => {

  const { activeSorts, sorts, onSetSort } = props

  const handleOnChange = (value: string) => {
    const toBeActiveSort: Sort = sorts.find(s => s.value === value)
    onSetSort({
      ...toBeActiveSort,
      desc: !!toBeActiveSort.desc
    })
  }

  const valueNames = sorts.reduce((acc, sort) => {
    acc[sort.value] = I18n.translate(`sort.mobile.${sort.valueLabel || sort.value}`)
    return acc
  }, {})

  const activeSort = activeSorts[0]
  let values = sorts.filter(sort => sort.value !== activeSort.value)
  values.sort((a, b) => I18n.translate(`sort.mobile.${valueNames[a.value]}`)
    .localeCompare(I18n.translate(`sort.mobile.${valueNames[b.value]}`), 'cs', { sensitivity: 'base' }))
  values = [activeSort].concat(values)

  return (
    <div className='form-group d-flex flex-row flex-wrap flex-sm-row align-items-top mb-3'>
      <div className='col-10 col-sm-3 order-0 order-sm-0 pt-sm-2 mt-sm-1 text-sm-right'>
        <FieldLabel
          id='mobileSort'
          label={I18n.translate('sort.mobileLabel')}
        />
      </div>
      <div className='col-12 col-sm-5 order-3 order-sm-0 offset-sm-1 mt-2 pr-sm-0'>
        <StringEnum
          enabled
          domain={{
            _type: 'string-enum',
            values: values.map(s => s.value),
          }}
          id='mobileSort'
          onChange={handleOnChange}
          valueNames={valueNames}
          value={activeSort.value}
        />
      </div>
    </div>
  )
}

export default MiniMobileSort
